export const environment = {
  production: false,
  apiUrl: 'https://storeserver.osmos-group.com/',
  googleMapsApiKey: 'AIzaSyAbdhAPSM--6ZTjaDVe3gsnb1ousLnDaQo',
  guardedRoute: 'api/',
  userLocalStored: '=VsVQet{gX5_aqud',
  levelLocalStored: 'selectedLevel_',
  clientId: '1_4q6p7p6kthc0k0884kcwkkossgskwck8cswg4kwcksc0gcwkc4',
  clientSecret: '4ell0swtjoys4k088gw4gckc4cko4wcc4w4w88cgokgg0gw0g4',
  grantType: 'password',
  pageSizeOptions: [5, 10, 20],
  pageSize: 10,
  userStatsTimeRange: '1_week',
  hubUrl: 'http://localhost:3000/.well-known/mercure',
  display_feature_export_async: true,
  enableLocalStorageViews: true,
  levelProjectDateLocked: [7],
  clientModeEnabled: true
};
